<template>
    <div class="file-container" @click="wrapperClicked">  
        <slot></slot>
        <input :multiple="multiple" type="file" @change="emitChanges" />
    </div>
</template>

<script>

// returns an array of file objects like this via @select event...
// {
//     lastModified:1533557260000
//     lastModifiedDate:Mon Aug 06 2018 22:07:40 GMT+1000 (AEST) {}
//     name:"README.md"
//     size:178
//     type:"text/markdown"
//     webkitRelativePath:""
// }

import Utilities from '../helpers/Utilities';
import DataHelpers from '../helpers/DataHelpers';
import AlertHelpers from '../helpers/AlertHelpers';
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

export default {
    data() {
        return {
        
        }
    },
    
    props: {
        multiple: {
            type: Boolean,
            default: true
        }
    },

    computed: {

    },

    methods: {
        wrapperClicked() {
            this.$emit('click')
        },
            
        emitChanges(event) {
            let files = [...event.target.files]
            this.$emit('select', files)
            event.target.value = null
        }
    }
}
</script>

<style scoped>
.file-container {
    overflow: hidden;
    position: relative;
}
.file-container [type=file] {
    cursor: inherit;
    display: block;
    font-size: 999px;
    filter: alpha(opacity=0);
    min-height: 100%;
    min-width: 100%;
    opacity: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
    cursor: pointer;
}   
</style>




// WEBPACK FOOTER //
// UploadWrapper.vue?7c19f86c